import React from "react";
import {Row, Col, Form, Input, Select} from 'antd';

const {Option} = Select;

const TabBalancas = ({dataTab})=> {

    
    return (
        <Row gutter={[16, 16]}>
           
           <Col span={8}>
                <Form.Item label="Envia Item para Balança?" name="enviaBalanca">
                    <Select data-tab={dataTab}>
                        <Option value={1}>SIM</Option>
                        <Option value={0}>NAO</Option>
                    </Select>
                </Form.Item>
            </Col>
            <Col span={8}>
                <Form.Item label="Imprime Validade" name="imprimeDataValidade">
                    <Select data-tab={dataTab}>
                        <Option value={1}>SIM</Option>
                        <Option value={0}>NAO</Option>
                    </Select>
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Imprime Data Embalagem" name="imprimeDataEmbalagem">
                    <Select data-tab={dataTab}>
                        <Option value={1}>SIM</Option>
                        <Option value={0}>NAO</Option>
                    </Select>
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Dias de Validade" name="diasValidade">
                    <Input  data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Código de informação nutricional" name="codigoInformacaoNutricional">
                    <Input data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Código Tara" name="codigoTara">
                    <Input data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Código Glaciamento" name="codigoGlaciamento">
                    <Input data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Código Informações Extra" name="codigoInformacaoExtra">
                    <Input data-tab={dataTab} />
                </Form.Item>
            </Col>
            
        </Row>
    );
}

export {TabBalancas};